module.exports = __webpack_public_path__ + "img/D07E3F_FBBD1F_8D2840_24120C-256px.e62804c3.png";